import {createRouter, createWebHashHistory, createWebHistory, createMemoryHistory} from 'vue-router'
import Home from '../views/Home.vue'
//import Model from '../views/Model.vue'
//import Help from "../views/Help";

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },
    // Hilfe
    // {
    //     path: '/help',
    //     component: Help
    //     //component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
    // },

    // 3D Modell

    // 3D Modell mit TextBanner
    // {
    //     path: '/titel',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/Titelbild.vue'),
    //     meta: {
    //         title: 'title'
    //     }
    // },

        // 3D Modell mit TextBanner
    // {
    //     path: '/promo1a',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/Promoloop_1a.vue'),
    //     meta: {
    //         title: 'promo1a'
    //     }
    // },

    //         // 3D Modell mit TextBanner
    // {
    //     path: '/promo1b',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/Promoloop_1b.vue'),
    //     meta: {
    //         title: 'promo1b'
    //     }
    // },

    {
        path: '/Alpen',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/010a_Zugspitze.vue'),
        meta: {
            title: 'Alpen'
        }
    },

    {
        path: '/Gletscher',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/010b_Zugspitze.vue'),
        meta: {
            title: 'Gletscher'
        }
    },

    // // 3D Modell mit TextBanner
    // {
    //     path: '/Zugspitze',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/010_Zugspitze.vue'),
    //     meta: {
    //         title: 'Zugspitze'
    //     }
    // },

    // 3D Modell mit TextBanner und Hotspot
    {
        path: '/Suedlicher_Schneeferner',
        component: () => import(/* webpackChunkName: "infobox" */ '../views/020_Suedlicher_Schneeferner.vue')
    },
    // 3D Modell mit TextBanner und HotspotComparison
    {
        path: '/Plattachferner',
        component: () => import(/* webpackChunkName: "infoboxcomparison" */ '../views/030_Plattachferner.vue')
    },


    // 3D Modell mit TextBanner und HotspotComparison
    {
        path: '/Skigebiet',
        component: () => import(/* webpackChunkName: "infoboxcomparison" */ '../views/040_Skigebiet.vue')
    },


    // 3D Modell mit TextBanner und HotspotComparison
    {
        path: '/Schneegrenze',
        component: () => import(/* webpackChunkName: "infoboxcomparison" */ '../views/050_Schneegrenze.vue')
    },

    // 3D Modell mit TextBanner und HotspotVideo
    {
        path: '/Ausblick',
        component: () => import(/* webpackChunkName: "infoboxvideo" */ '../views/060_Ausblick.vue')
    },

    // Credits
    {
        path: '/Credits',
        component: () => import(/* webpackChunkName: "credits" */ '../views/070_Credits.vue'),
        meta: {
            title: 'Credits'
        }
    },

];

function getHistory()
{
    if (process.env.VUE_APP_ROUTER_MODE === 'hash')
    {
        return createWebHashHistory();
    }

    if (process.env.VUE_APP_ROUTER_MODE === 'history')
    {
        return createWebHistory();
    }

    return createMemoryHistory();
}

const router = createRouter({
    history: getHistory(),
    base: process.env.BASE_URL,
    routes
});

export default router
